import { hasKey } from '../typescript/guards'

export type ShopifyEvent = {
  originalEvent: {
    detail: {
      sectionId: string
    }
  }
}

export const _isShopifyEvent = function (evt: unknown): evt is ShopifyEvent {
  return (
    hasKey('originalEvent', evt) &&
    hasKey('detail', evt.originalEvent) &&
    hasKey('sectionId', evt.originalEvent.detail) &&
    typeof evt.originalEvent.detail.sectionId === 'string' &&
    evt.originalEvent.detail.sectionId.length > 0
  )
}

export type FilterSections = (
  shopifyEvent?: unknown
) => (index: number, element: HTMLElement) => boolean

/**
 * jQuery section filter function
 * Filters elements by Shopify section ID.
 * If the section ID is undefined, all sections are selected
 */
export const filterSections: FilterSections = function filterSections(
  shopifyEvent
) {
  const sectionId: string = _isShopifyEvent(shopifyEvent)
    ? shopifyEvent.originalEvent.detail.sectionId
    : ''

  return function (_, element): boolean {
    return !sectionId
      ? true
      : element.getAttribute('id') === 'shopify-section-' + sectionId
      ? true
      : element.getAttribute('data-section-id') === sectionId
  }
}
